import { useFetchBatchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { isLoading, isError } from 'reference-resolvers-lite/Status';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import LoadingValue from '../value/LoadingValue';
import { indexBy } from '../utils/indexBy';
import UITag from 'UIComponents/tag/UITag';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const indexById = indexBy(({
  id
}) => id);
export const FormattedCrmObjectTags = ({
  resolver,
  value
}) => {
  const values = parseMultiEnumValue(value);
  const {
    references,
    status
  } = useFetchBatchResolver(resolver, values);
  if (isError(status)) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: values.map(id => {
        return /*#__PURE__*/_jsx(UITag, {
          children: id
        }, id);
      })
    });
  }
  if (isLoading(status)) {
    return /*#__PURE__*/_jsx(LoadingValue, {});
  }
  if (!references) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: EMPTY_PROPERTY_VALUE
    });
  }
  const byIdMap = indexById(references);
  const tags = values.map(id => {
    const idStr = String(id);
    const reference = Object.prototype.hasOwnProperty.call(byIdMap, idStr) ? byIdMap[idStr] : undefined;
    if (!reference) {
      return {
        id,
        label: `${id}`
      };
    }
    if (!reference.label) {
      return {
        id,
        label: `${reference.id}`
      };
    }
    return reference;
  }).sort((tagA, tagB) => {
    if (!tagA.additionalProperties && !tagB.additionalProperties) {
      return Number(tagA.id) - Number(tagB.id);
    } else if (!tagA.additionalProperties) {
      return 1;
    } else if (!tagB.additionalProperties) {
      return -1;
    }
    return (Number(tagA.additionalProperties.displayOrder) || 0) - (Number(tagB.additionalProperties.displayOrder) || 0);
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: tags.map(tag => {
      const color = tag.additionalProperties && tag.additionalProperties.color || 'default';
      return /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs("b", {
              children: [tag.label, ":"]
            })
          }), /*#__PURE__*/_jsx("div", {
            children: tag.description
          })]
        }),
        disabled: !tag.description,
        children: /*#__PURE__*/_jsx(UITag, {
          use: color,
          truncateStringProps: {
            tooltip: !tag.description
          },
          children: tag.label
        })
      }, tag.id);
    })
  });
};
export default FormattedCrmObjectTags;